import { TimeBlockStatus } from '../../common/time-block-status';

export interface ITimeBlockListing {
    id: string;
    status: TimeBlockStatus;
    date: number;
    sequenceNumber: number;
    blockNumber: number;
    isBillableTime: boolean;
    isSelected: boolean;
}


export class TimeBlockListing implements ITimeBlockListing {
    public id: string = '';
    public status: TimeBlockStatus = TimeBlockStatus.Available;
    public date: number = 0;
    public sequenceNumber: number = 0;
    public blockNumber: number = 0;
    public isBillableTime: boolean = false;
    public isSelected: boolean = false;
}


